import React, { Component } from "react";
import moment from 'moment';
import CancelBooking from '../home/CancelBooking';
import { bookmarkClass } from  '../../utils/bookmarkClass';
import { openLiveClass } from  '../../utils/openLiveClass';
import { connect } from "react-redux";
import { showMainErrorPop } from '../../actions/popups';
import axiosVirdioT from '../../utils/axios';
var axiosVirdio;

class ChallengeDetails extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		currentUserData: localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : {},
		defaultJoinTime: localStorage.getItem('userData') ? parseInt(JSON.parse(localStorage.getItem('userData')).default.defaultSessionDuration) : 15,
		isOpenActivity: false,
		isOpenEquipment: false,
		challengeData: [],
		previousClasses: [],
		upcomingClasses: [],
		currentTime: 0,
		timerInterval: null,
		isOpenWorkoutVideo: false,
		videoURL: '',
		videoName: '',
		classBoking: false,
		sessionToCancel: 0,
		videoDescription: '',
		isOpenInstructorInfo: false,
		isClicked: false
    }
	
	this.bookmarkClass = bookmarkClass.bind(this);
	this.openLiveClass = openLiveClass.bind(this);
	//this.joinChallenge = joinChallenge.bind(this);
}
 
componentDidMount(){
	this.setState({
			challengeData: this.props.groupInfo
		})
	axiosVirdio = new axiosVirdioT(this.props);
	this.challengeTimer(this);
	this.countdownTimer();
}

componentWillUnmount(){
	clearInterval(this.state.timerInterval);
}

openCloseWorkout=()=>{
	var isOpenWorkout = this.state.isOpenActivity;
	isOpenWorkout = !isOpenWorkout;
	this.setState({isOpenActivity: isOpenWorkout});
}

openCloseEquipment=()=>{
	var isOpenEq = this.state.isOpenEquipment;
	isOpenEq = !isOpenEq;
	this.setState({isOpenEquipment: isOpenEq});
}

bookMarkClass=(e, item)=>{
	
	if ( this.props && this.props.failedPaymentStatus )
		{
			return false;	
		}
	
	var statusClass = 1;
	if ( item.isBookmarked == 1 ) { statusClass = 0; }
	
	var mainthis = this;
	this.bookmarkClass(item.sessionId, 1, statusClass).then(function(res){
		mainthis.props.getChallenges(true, true);
	}, function (err) { 
		if ( err.response && err.response.data && err.response.data.errorData ) 
			{
				mainthis.props.showMainErrorPop(err.response.data.errorData); 
			}
	});
}

openClass=(id, ondemandid, item)=>{
	this.props.openClass(id, ondemandid ? 'ondemand' : 'live');
	var groupClass = {};
	
	if ( !!item )
		{
			groupClass.groupId = this.state.challengeData.id;
			groupClass.groupClassId = item;
			localStorage.setItem("groupClass", JSON.stringify(groupClass));
		}
	else
		{
			localStorage.removeItem("groupClass");
		}
}

openCancel=(id)=>{
	this.setState({classBoking: true, sessionToCancel: id});
	if ( this.props && this.props.openCancelTrigger )
		{
			this.props.openCancelTrigger();
		}
}

cancelSessionStatus = ()=>{
	var challengeData = this.state.challengeData[0];
	var allClasses = this.state.challengeData.classes;
	this.state.challengeData.classes.map((date, index) =>
		{
			this.state.challengeData.classes.map((item, i) =>
				{
					if ( allClasses[i]['sessionId'] == this.state.sessionToCancel )
						{
							allClasses[i]['bookingStatus'] = 4;
						}							
				});
		});
	
	this.setState({
			challengeData: [...challengeData, 'classes': allClasses],
			classBoking: false,
			sessionToCancel: 0
		});
	
	this.props.updateStateFromChild({isOpenCancel: false});
}

bookSession = (id)=>{
	
	if ( this.props && this.props.state && this.props.state.failedPaymentStatus )
		{
			return false;
		}
	
	var postData = {
		sessionId: id
	};
	let token = JSON.parse(localStorage.getItem('userData')).token;
	axiosVirdio.auth(token);	 
	this.props.updateStateFromChild({showLoader: true});
	axiosVirdio.post(process.env.REACT_APP_API_URL +'/api/v1/session/bookSessionMarketplace', postData).then(res => {
		var challengeData = this.state.challengeData[0];
		var allClasses = this.state.challengeData.classes;
		this.state.challengeData.classes.map((date, index) =>
			{
				this.state.challengeData.classes.map((item, i) =>
					{
						if ( allClasses[i]['sessionId'] == id )
							{
								allClasses[i]['bookingStatus'] = 0;
							}
					});
			});
		
		this.setState({challengeData: [...challengeData, 'classes': allClasses]});
		this.props.updateStateFromChild({showLoader: false});
	}).catch(err =>{
		
		let msg = '';
		if ( err.response && err.response.data.errorData )
			{
				msg = err.response.data.errorData;
			}
		if ( err.response && err.response.data.errorData.message && err.response.data.errorData.message != '' )
			{
				msg = err.response.data.errorData.message;
			}
		this.props.showMainErrorPop(msg);
		this.props.updateStateFromChild({showLoader: false});
	});
}

playWorkVideo=(item)=>{
	this.setState({isOpenWorkoutVideo: true, videoURL: item.activityVideo, videoName: item.activityName, videoDescription: item.activityDescription})
}

playClass=(id)=>{
	
	console.log('join');
}

updateStateFromChild=(state)=>{
	this.setState(state);
}

updateClassDetails=(details)=>{
	this.setState({challengeData: details});
}

openInstructorInfo=()=>{
	this.setState({
		isOpenInstructorInfo: true,
	});
}

challengeTimer=(mainthis)=>{ var timerInterval = setInterval(function timerInterval() {
		mainthis.setState({currentTime: moment()});
	}, 1000);
	if ( this.props.isOpenDetailedClass )
		{
			mainthis.setState({timerInterval: timerInterval});
		}
	else {clearInterval(mainthis.state.timerInterval)};
}

countdownTimer() {
	let mainthis = this;
    var x = setInterval(function() {
			
			if ( !mainthis.state.challengeData.classes )
				{
					return false;
				}
			
			var challengeData = mainthis.state.challengeData;
			var allClasses = mainthis.state.challengeData.classes;
			
			mainthis.state.challengeData.classes.map((item, index) =>
				{
					var timeRemaining = Math.floor((new Date(item.scheduleDate).getTime() - new Date().getTime())/1000);
					var timeOpenStart = timeRemaining - 300;
					var sessionRemaining = (allClasses[index]['sessionDuration'] * 60) + timeRemaining;
					allClasses[index]['timeUntil'] = timeOpenStart;					
					if ( sessionRemaining <= 0 )
						{
							allClasses[index]['sessionCompleted'] = 1;
						}
				});
			
			challengeData.classes = allClasses;
			
			mainthis.setState({challengeData: challengeData});
	}, 1000); 
}

  render() {
	
	const challengeData = this.state.challengeData ? this.state.challengeData : [];
	var upcoming = this.state.challengeData.classes ? this.state.challengeData.classes.filter(item => new Date(moment()) < new Date(item.scheduleDate)) : [];
	var previous = this.state.challengeData.classes ? this.state.challengeData.classes.filter(item => new Date(moment()) > new Date(item.scheduleDate)) : [];
	
	var currentTime = this.state.currentTime;
	var challengeStarted = challengeData && challengeData.start_date && moment(challengeData.start_date).diff(currentTime) > 0 ? false : true;
	var utcDiff = challengeData && challengeData.end_date ? (challengeStarted ? moment(challengeData.end_date).diff(currentTime) : moment(challengeData.start_date).diff(currentTime)) : 0;
	var timeDiff = moment(utcDiff).format('D:hh:mm:ss').toString();
	if (utcDiff < 0) {timeDiff = '0:00:00:00'; clearInterval(this.state.timerInterval);}
	timeDiff = timeDiff.split(':');
	
	var dayDiff = timeDiff[0];
	var hourDiff = timeDiff[1];
	var minuteDiff = timeDiff[2];
	var secDiff = timeDiff[3];
	
	return (
		<div className="programs_content">
			{(this.state.challengeData.joined == 1 || utcDiff <= 0) && 
				<div className="program_title p_title_no_padd">{this.state.challengeData.name}</div> 
			}
			<div className={"programs_main " + (this.props.groupInfo && this.props.groupInfo.joined == 1 ? "p_main_no_padd" : '')}>
				{ this.props.groupInfo &&
					<>
						{this.state.challengeData.joined == 1 && 
							<>
							{/*<div className="program_title p_title_no_padd">{this.state.challengeData.name}</div> */}
							<div className="achievements_header">
								<div className="ach_container">
									<div className="ach_streak_area">
										<div className={"ach_image "+(this.state.challengeData.classes != undefined && this.state.challengeData.classes.length == this.state.challengeData.days_streak ? "ach_done" : "ach_days")}></div>
										<div className="ach_streak">{this.state.challengeData.days_streak}/{this.state.challengeData.classes != undefined ? this.state.challengeData.classes.length : ''}</div>
									</div>
									<div className="ach_title">Days streak</div>
								</div>
								<div className="ach_container">
									<div className="ach_streak_area">
										<div className={"ach_image "+(this.state.challengeData.classes != undefined && this.state.challengeData.classes.length == this.state.challengeData.total_classes ? "ach_done" : "ach_classes")}></div>
										<div className="ach_streak">{this.state.challengeData.total_classes}/{this.state.challengeData.classes != undefined ? this.state.challengeData.classes.length : ''}</div>
									</div>
									<div className="ach_title">Total classes</div>
								</div>
								<div className="ach_container">
									<div className="ach_streak_area">
										<div className={"ach_image " +(moment(new Date(null).setSeconds(this.state.challengeData.seconds_today)) >= moment(new Date(null).setSeconds(this.state.challengeData.daily_time_minutes * 60)) ? "ach_done" : "ach_minutes")}></div>
										<div className="ach_streak">{moment(new Date(null).setSeconds(this.state.challengeData.seconds_today)).format('m:ss')}/{moment(new Date(null).setSeconds(this.state.challengeData.daily_time_minutes * 60)).format('m:ss')}</div>
									</div>
									<div className="ach_title">Minutes today</div>
								</div>
							</div>
							</> }
						<div className="program_data_left">
							{this.state.challengeData.joined == 0 && utcDiff > 0 ?
								<>
									<div className="enroll_text">Enroll by {moment(this.state.challengeData.start_date).format('LL')}</div>
									<div className="program_title">{this.state.challengeData.name}</div>
									<div className="program_join_btn">
										<div className="program_join_text" onClick={() => this.props.joinChallenge(this.props.groupInfo.id)}>Join Challenge</div>
									</div> 
								</> :
								<>
									<div className={"enroll_text" + (utcDiff <= 0 ? ' d-none': '')}>Participate by {moment(this.state.challengeData.end_date).format('LL')}</div>
									<div className={"enroll_timer" + (utcDiff > 0 ? " e_t_active" : '')}>
										<div className="enroll_timer_upper">
											{dayDiff}
											<span>:</span>
											{hourDiff}											
											<span>:</span> 
											{minuteDiff}
											<span>:</span> 
											{secDiff}
										</div>
										<div className="enroll_timer_small_text">
											days
											<div className="e_t_small_second">hours</div>
											<div className="e_t_small_third">minutes</div>
											<span>seconds</span>
										</div>
									</div>
								</>}
							<div className="program_description">{this.props.groupInfo.description}</div>
							<div className="ch_props_bottom">
								{ !!this.props.groupInfo.reward &&
									<div className="ch_info_props_hold">
										<div className="ch_tab_icon ch_reward_icn_blk"></div>
										<div className="ch_tab_text">${this.props.groupInfo.reward}</div>
								</div> }
								<div className="ch_info_props_hold">
									<div className="ch_tab_icon ch_classes_icn_blk"></div>
									<div className="ch_tab_text">{this.state.challengeData.classes != undefined ? this.state.challengeData.classes.length : '0'} classes</div>
								</div>
								<div className="ch_info_props_hold">
									<div className="ch_tab_icon ch_duration_icn_blk"></div>
									<div className="ch_tab_text">{this.state.challengeData.duration} Days</div>
								</div>
								<div className="ch_info_props_hold">
									<div className="ch_tab_icon ch_minutes_icn_blk"></div>
									<div className="ch_tab_text">{this.state.challengeData.daily_time_minutes} minutes /day</div>
								</div>
							</div>
						</div>
					</>
				}
				<div className="program_classes">
					{this.state.challengeData.classes != undefined && previous.length > 0 &&
						<div className="program_upcoming">Classes</div>
					}
					{ this.state.challengeData.classes != undefined && previous.map((item, i) =>
						<div className="class_content">
							<div className="left_class_content ch_left_class">
								<div className="top_class_content">
									<><div className="class_time">{moment(item.scheduleDate).format('LL')}</div></>
									{ item.ondemandId <= 0 && <><div className="class_dot">&bull;</div>
									<div className="class_time">{moment(item.scheduleDate).format('hh:mm A')}</div></> }
									
									<div className="class_dot">&bull;</div>
									<div className="class_time">{item.sessionDuration} min</div>
									<div className="class_interest ch_interest">{item.interestTitles}</div>
									{item.replayClassId > 0 &&
										<div className="class_interest ch_interest">Replay</div> 
									}
									{item.ondemandId > 0 ?
										<div className="class_interest ch_interest">On-Demand</div> 
										:
										<div className="class_interest ch_interest">Live</div> 
									}
									{item.isComplete == 1 &&
										<div className="class_interest ch_interest ch_class_complete">Completed</div> 
									}
								</div>
								<div className="class_name">{item.sessionName}</div>
								<div className="bottom_class_content">
									<div className="instructor_avatar" style={{ backgroundImage: item.hostImage && item.hostImage.indexOf('.s3') > -1 ? "url("+item.hostImage+")" : "url(./images/user_avatar.svg)"}}></div>
									<div className="instructor_name">{item.hostFirstName} {item.hostLastName}</div>
								</div>
							</div>
							<div className={"ch_class_right" + ((this.state.challengeData.joined == 0 || (item.sessionCompleted > 0 && item.ondemandId == 0)) ? " d-none" : '')}>
								{item.timeUntil > 0 && item.ondemandId == 0 ?
									<div className={"class_inactive_btn ch_class_right_btn " + (item.bookingStatus == 0 || item.bookingStatus == 1 ? '' : ' d-none')}>Booked</div>
								:
								challengeStarted ?
								<div className="class_active_btn ch_class_right_btn" onClick={() => this.openClass(item.sessionId, item.ondemandId, utcDiff > 0 ? item.groupClassId : false)}>{item.ondemandId > 0 ? "Take Class" : "Start Class"}</div> : ''}
							</div>
						</div>
					)}
					{this.state.challengeData.classes != undefined &&
						<div className="program_upcoming">Upcoming classes ({upcoming.length})</div>
					}
					{ this.state.challengeData.classes != undefined && upcoming.map((item, i) =>
						<div className="class_content">
							<div className="left_class_content ch_left_class">
								<div className="top_class_content">
									<><div className="class_time">{moment(item.scheduleDate).format('LL')}</div></>
									{ item.ondemandId <= 0 && <><div className="class_dot">&bull;</div>
									<div className="class_time">{moment(item.scheduleDate).format('hh:mm A')}</div></>}
									
									<div className="class_dot">&bull;</div>
									<div className="class_time">{item.sessionDuration} min</div>
									<div className="class_interest ch_interest">{item.interestTitles}</div>
									{item.replayClassId > 0 &&
										<div className="class_interest ch_interest">Replay</div> 
									}
									{item.ondemandId > 0 ?
										<div className="class_interest ch_interest">On-Demand</div> 
										:
										<div className="class_interest ch_interest">Live</div> 
									}
									{item.isComplete == 1 &&
										<div className="class_interest ch_interest ch_class_complete">Completed</div> 
									}
								</div>
								<div className="class_name">{item.sessionName}</div>
								<div className="bottom_class_content">
									<div className="instructor_avatar" style={{ backgroundImage: item.hostImage && item.hostImage.indexOf('.s3') > -1 ? "url("+item.hostImage+")" : "url(./images/user_avatar.svg)"}}></div>
									<div className="instructor_name">{item.hostFirstName} {item.hostLastName}</div>
								</div>
							</div>
							<div className={"ch_class_right" + ((this.state.challengeData.joined == 0 || (item.sessionCompleted > 0 && item.ondemandId == 0)) ? " d-none" : '')}>
								{item.timeUntil > 0 && item.ondemandId == 0 ?
									<div className={"class_inactive_btn ch_class_right_btn " + (item.bookingStatus == 0 || item.bookingStatus == 1 ? '' : ' d-none')}>Booked</div>
								:
								challengeStarted ?
								<div className="class_active_btn ch_class_right_btn" onClick={() => this.openClass(item.sessionId, item.ondemandId, utcDiff > 0 ? item.groupClassId : false)}>{item.ondemandId > 0 ? "Take Class" : "Start Class"}</div> : ''}
							</div>
						</div>
					)}
				</div>
				{ this.state.challengeData.length == 0 &&
					<div className="empty_details">Challenge not available anymore.</div>
				}
			</div>
			
			{ this.state.classBoking == true &&
				<CancelBooking updateStateFromChild={this.updateStateFromChild} cancelSessionStatus={this.cancelSessionStatus} sessionId={this.state.sessionToCancel}></CancelBooking>
			}
			
			
		</div>
    );
  }
}

export default connect(
  null,
  { 
	showMainErrorPop
  },
  null,
  {forwardRef: true}
)(ChallengeDetails);
